<ng-container *mobxAutorun>
  <ng-container *ngIf="shouldDisplay">
    <!-- Label -->
    <span *ngIf="label" class="label">{{ label }}</span>
    <lf-help-tooltip *ngIf="helpMessage" [help]="helpMessage"></lf-help-tooltip>

    <!-- Required icon -->
    <lf-icon
      class="is-required"
      icon="asterisk"
      *ngIf="showIsRequired && !isReadOnly"
    ></lf-icon>

    <!-- Pending validation -->
    <div
      class="status pending"
      *ngIf="relativeStorage.shouldShowPending()"
    ></div>
    <!-- Rejected validation -->
    <div
      class="status rejected"
      *ngIf="relativeStorage.shouldShowRejected()"
      (click)="relativeStorage.recomputeStateProperties()"
    >
      <lf-tooltip [help]="retryValidateText">
        <lf-icon icon="warning"></lf-icon>
      </lf-tooltip>
    </div>

    <!-- (Debug) value state -->
    <lf-value-state [path]="path"></lf-value-state>

    <!-- Input group -->
    <div
      class="lf-checkable-group input-group input-group-sm"
      [class.is-warning]="relativeStorage.shouldShowWarning()"
      [class.is-invalid]="relativeStorage.shouldShowError()"
    >
      <!-- Code -->
      <div *ngIf="code" class="input-group-prepend">
        <div class="input-group-text">{{ code }}</div>
      </div>

      <!-- Radios -->
      <div
        class="lf-checkables form-control"
        [class.is-warning]="relativeStorage.shouldShowWarning()"
        [class.is-invalid]="relativeStorage.shouldShowError()"
        [class.is-readonly]="isReadOnly"
        [class.display-inline]="displayInline"
      >
        <!-- Text for when there are no options -->
        <div
          *ngIf="optionsStatus !== 'pending' && options.length === 0"
          class="no-options"
        >
          {{ noOptionsText }}
        </div>

        <!-- Pending options -->
        <div *ngIf="optionsStatus === 'pending'" class="pending-options"></div>

        <div
          class="lf-checkable input-group input-group-sm"
          *ngFor="let option of options; let i = index"
        >
          <!-- Code of each radio -->
          <div *ngIf="option.code" class="input-group-prepend">
            <div class="input-group-text">{{ option.code }}</div>
          </div>

          <!-- Radio -->
          <label
            class="form-control custom-control custom-radio"
            [class.is-warning]="relativeStorage.shouldShowWarning()"
            [class.is-invalid]="relativeStorage.shouldShowError()"
            [class.is-readonly]="isReadOnly"
          >
            <!-- Actual radio -->
            <!--
              Note that radios don't support `readonly`, so we use the
              `disabled` attribute
            -->
            <input
              #focusTarget
              type="radio"
              class="custom-control-input"
              [name]="path"
              [value]="i"
              [checked]="selectedOptionIndex === i"
              [disabled]="isReadOnly"
              (change)="_onRadioChange($event)"
              (focus)="_onFocus($event)"
              (blur)="_onBlur($event)"
            />

            <!-- Radio label -->
            <span class="custom-control-label">
              <span>{{ option.label }}</span>
              <lf-help-tooltip
                *ngIf="option.helpMessage"
                [help]="option.helpMessage"
              ></lf-help-tooltip>
            </span>
          </label>
        </div>
      </div>
    </div>

    <!-- Legend -->
    <div *ngIf="legend" class="legend">{{ legend }}</div>
  </ng-container>
</ng-container>
